import {
  config as faConfig,
  dom as faDom,
  library,
} from '@fortawesome/fontawesome-svg-core';
import * as Icons from '@fortawesome/free-solid-svg-icons';
import * as IconsRegular from '@fortawesome/free-regular-svg-icons';
import * as IconsBrand from '@fortawesome/free-brands-svg-icons';
import { Sitemap } from '@plone/volto/components';
import itinerarySVG from '@redturtle/iovisit-theme/icons/itinerary.svg';
import pointOfInterestSVG from '@redturtle/iovisit-theme/icons/point-of-interest.svg';
import restaurantSVG from '@redturtle/iovisit-theme/icons/restaurant.svg';
import accomodationSVG from '@redturtle/iovisit-theme/icons/accomodation.svg';
import eventSVG from '@redturtle/iovisit-theme/icons/event.svg';
import subsiteSVG from '@redturtle/iovisit-theme/icons/subsite.svg';
import WhishlistPage from '@redturtle/iovisit-theme/components/Views/WhishlistPage/WhishlistPage';
import Favicon from '@redturtle/iovisit-theme/components/layout/Favicon/Favicon';
import HandleMenuFocus from '@redturtle/iovisit-theme/components/HandleMenuFocus/HandleMenuFocus';
import installSlateConfig from '@redturtle/iovisit-theme/config/Slate';
import CustomParagraph from '@redturtle/iovisit-theme/components/CustomParagraph/CustomParagraph';
import GenericAppExtras from '@redturtle/iovisit-theme/components/GenericAppExtras/GenericAppExtras';

import { MultilingualWidget } from 'volto-multilingual-widget';
import { ColorPickerWidget } from '@plone/volto/components';

import {
  IoVisitConfig,
  IoVisitBlocks,
  IoVisitWidgets,
  IoVisitViews,
  IoVisitRoutes,
} from '@redturtle/iovisit-theme/config';
import IoVisitSlots from '@redturtle/iovisit-theme/config/slots';
import {
  searchFiltersStructures,
  searchResults,
  searchFiltersEvents,
  whishlist,
} from '@redturtle/iovisit-theme/reducers';

//FontAwesome icons
faConfig.autoAddCss = false;
const iconList = Object.keys(Icons.fas).map((icon) => Icons[icon]);
const iconListRegular = Object.keys(IconsRegular.far).map(
  (icon) => IconsRegular[icon],
);
const iconListBrand = Object.keys(IconsBrand.fab).map(
  (icon) => IconsBrand[icon],
);
library.add(...iconList, ...iconListRegular, ...iconListBrand);

const applyConfig = (config) => {
  //config.settings.bbb_listingBlockFetchesFullobjects = true; //da togliere
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['it'];
  config.settings.defaultLanguage = 'it';
  config.settings.timezone = 'Europe/Rome';
  config.settings.verticalFormTabs = true;
  config.settings.showTags = false;
  config.settings.showSelfRegistration = false;
  config.settings.showWishlistWidget = true;
  config.settings.defaultPageSize = 24;
  config.settings['volto-editablefooter'] = {
    options: { socials: false, newsletterSubscribe: false },
  };

  const voltoSentryOptions = config.settings.sentryOptions;
  config.settings.sentryOptions = (libraries) => {
    const options = voltoSentryOptions(libraries);
    return {
      ...options,
      ignoreErrors: [
        ...options.ignoreErrors,
        'window.webkit.messageHandlers', //errore in-app browser Facebook/Instagram su iOS
      ],
      // https://docs.sentry.io/platforms/javascript/data-management/sensitive-data/
      // beforeSend(event) {
      //   // Modify the event here (e.g.)
      //   // if (event.user) {
      //   //   delete event.user.email;
      //   // }
      //  return event;
      // },
    };
  };

  installSlateConfig(config);

  config.settings.persistentReducers = [
    ...config.settings.persistentReducers,
    'whishlist',
  ];
  config.settings.contentIcons = {
    ...config.settings.contentIcons,
    Event: eventSVG,
    Itinerary: itinerarySVG,
    PointOfInterest: pointOfInterestSVG,
    Restaurant: restaurantSVG,
    Accomodation: accomodationSVG,
    Subsite: subsiteSVG,
  };

  config.settings.markSpecialLinks = false;

  config.settings.iovisit = IoVisitConfig;
  IoVisitSlots(config);
  IoVisitRoutes(config);
  IoVisitWidgets(config);
  IoVisitViews(config);
  IoVisitBlocks(config);

  config.addonReducers = {
    ...config.addonReducers,
    searchFiltersStructures,
    searchResults,
    searchFiltersEvents,
    whishlist,
  };

  config.addonRoutes = [
    ...config.addonRoutes,
    {
      path: '*/wishlist',
      component: WhishlistPage,
    },
    {
      path: '/**/sitemap',
      component: Sitemap,
    },
  ];

  config.settings.nonContentRoutes = [
    ...config.settings.nonContentRoutes,
    '/wishlist',
  ];

  config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: '',
      component: () => <style type="text/css">{faDom.css()}</style>, //load fontawesom dom css
    },
    {
      match: '',
      component: Favicon,
    },
    {
      match: '',
      component: HandleMenuFocus,
    },
    {
      match: '',
      component: GenericAppExtras,
    },
  ];

  config.settings['volto-gdpr-privacy'].defaultPanelConfig.text.it.description =
    "Questo sito utilizza i cookie tecnici di navigazione e di sessione per garantire un miglior servizio di navigazione del sito, e cookie analitici per raccogliere informazioni sull'uso del sito da parte degli utenti.  Utilizza anche cookie di profilazione dell'utente per fini statistici. Per i cookie di profilazione puoi decidere se abilitarli o meno cliccando sul pulsante 'Impostazioni'. Per saperne di più, su come disabilitare i cookie oppure abilitarne solo alcuni, consulta la nostra <a href='/it/privacy-policy'>Cookie Policy</a>.";

  config.settings.slate.elements = {
    ...config.settings.slate.elements,
    p: CustomParagraph,
  };

  return config;
};

export default applyConfig;
